export enum EUserCardTab {
  About = 'clientInfo',
  Photos = 'photos',
}
